import React from 'react';

/**
 * Reusable empty-state placeholder.
 */
export function EmptyState({ icon, title, body, className = '' }) {
  return (
    <div className={`msml-card text-center py-16 ${className}`} data-testid="empty-state">
      {icon && (
        <div className="mx-auto mb-4 text-[var(--msml-text-muted)] opacity-30">
          {icon}
        </div>
      )}
      <p className="text-[var(--msml-text-muted)]">{title}</p>
      {body && <p className="text-xs text-[var(--msml-text-muted)] mt-1 opacity-60">{body}</p>}
    </div>
  );
}
